<template>
  <div>
    <label class="small">{{ label }}</label>
    <select :value="value" @input="$emit('change', $event.target.value)" class="form-select">
      <option class="disabled" value="" selected>{{ dictionary.utilities.defaultFont }}</option>
      <optgroup :label="dictionary.utilities.baseFont">
        <option v-for="(ft, key) in baseFont" :key="key" :value="ft.value">{{ ft.name }}</option>
      </optgroup>
      <optgroup v-if="(serverFont || []).length > 0" :label="dictionary.utilities.exoticFont">
        <option v-for="(ft, key) in serverFont" :key="key" :value="ft.value">{{ ft.name }}</option>
      </optgroup>
      <optgroup
        v-if="Object.keys(importedFonts || {}).length > 0"
        :label="dictionary.utilities.importedFonts"
      >
        <option
          v-for="(ft, key) in importedFonts"
          :key="key"
          :value="`${ft.family}${ft.category ? `, ${ft.category}` : ''}`"
        >
          {{ ft.family }} (Google Fonts)
        </option>
      </optgroup>
    </select>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { baseFont, serverFont } from '../../configuration/defaultFont.json';

export default {
  name: 'FontSelector',
  props: {
    value: String,
    label: String,
    importedFonts: Object,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  computed: {
    ...mapGetters(['dictionary']),
    serverFont() {
      return serverFont;
    },
    baseFont() {
      return baseFont;
    },
  },
};
</script>

<style scoped></style>
